
/* injects from baggage-loader */

'use strict';

import StageBaseController from '../stage-base.controller';

import { perguntas, palavras, elements1, elements2 } from './stage-one.const';

import _ from "lodash";

export default class StageOneController extends StageBaseController {
	constructor($log, $state, $q, Session, Dialog) {
		'ngInject';
		super($log, $state, $q, Session, Dialog);
		this.perguntas = perguntas;
		this.palavras = palavras;		

		this.awnserValue = "";
		this.prize = "mapa";

		this.relation = 4;
		this.numAld = 8;
		this.numLar = 90;
		this.stageName = "Oeste";
	}

	$onInit() {
		this.checkStage();
	}

	prepareQuestion(name){
		let $ctrl = this;
		switch(name){
			case 'Oeste':
			default:
			this.elements = elements1;
			this.Dialog.showTutorial('m3');
			this.randomizeValues([2,8],[30,90])
			this.elQuant(this.perguntas[0],this.relation,this.numAld);
			this.elements.forEach(function(obj){
				$ctrl.checkGrid(obj);
			});
			break;
			case 'Oeste-2':
			this.prize = "green";
			this.elements = elements2;
			this.randomizeValuesDiffer([4,15],[4,10])
			this.elQuant(this.perguntas[1],this.linesModel[1].caixa,this.linesModel[0].laranja);
			this.elements.forEach(function(obj){
				$ctrl.checkGrid(obj);
			});
			break;
		}
	}

	checkGrid(obj){
		let num = obj.value;
		if(this.stageName === 'Oeste-2'){
			if(num<=8){
				obj.parentStyle['justify-content'] = 'center';
				obj.style.width = '80px';
				obj.style.height = '80px';
				obj.style.padding = '2xp';
			}
			else if(num<=21){
				obj.parentStyle['justify-content'] = 'flex-start';
				obj.style.width = '48px';
				obj.style.height = '48px';
				obj.style.padding = '2xp';
			}
			else if(num<=50){
				obj.parentStyle['justify-content'] = 'flex-start';
				obj.style.width = '32px';
				obj.style.height = '32px';
				obj.style.padding = '2xp';
			}
			else if(num<=84){
				obj.parentStyle['justify-content'] = 'flex-start';
				obj.style.width = '24px';
				obj.style.height = '24px';
				obj.style.padding = '2xp';
			}
			else if(num<=152){
				obj.parentStyle['justify-content'] = 'flex-start';
				obj.style.width = '18px';
				obj.style.height= '18px';
				obj.style.padding = '2xp';
			}
			else if(num<=230){
				obj.parentStyle['justify-content'] = 'flex-start';
				obj.style.width = '15px';
				obj.style.height = '15px';
				obj.style.padding = '1xp';
			}
			else if(num<=377){
				obj.parentStyle['justify-content'] = 'flex-start';
				obj.style.width = '12px';
				obj.style.height = '12px';
				obj.style.padding = '0xp';
			}
			else if(num<=560){
				obj.parentStyle['justify-content'] = 'flex-start';
				obj.style.width = '10px';
				obj.style.height = '10px';
				obj.style.padding = '0px';
			}
		} else {
			super.checkGrid(obj);
		}
		return false;
	}

	getNumber(num){
		if(num > 0){
			return new Array(num);
		}
		else{
			return [];
		}
	}

	randomizeValues(aldRange, aldXlarRange){
		let numAld = this.getRandomInt(aldRange);
		let numAldXlar = this.normalizeFive(this.getRandomInt(aldXlarRange));
		let numLar = numAldXlar * numAld;

		this.relation = numAldXlar;
		this.numAld = numAld;
		this.numLar = numLar;

		this.expected = numAld;
		this.linesModel = numLar;

		this.elements[1].value = this.relation;
		this.elements[1].minValue = this.relation;
	}

	randomizeValuesDiffer(caixaRange, frutaXcaixaRange){
		let numcaixaXcaixote = this.getRandomInt(caixaRange);
		let numfrutaXcaixa = this.getRandomInt(frutaXcaixaRange);

		let numLarOne = numcaixaXcaixote * numfrutaXcaixa;
		let numCaixOne = 3 * numcaixaXcaixote;
		let numLarTotal = 3 * numcaixaXcaixote * numfrutaXcaixa;

		this.elements[0].value = 1;
		this.elements[1].value = numcaixaXcaixote;
		this.elements[2].value = numLarOne;

		this.linesModel = [
		{
			caixote: 0,
			caixa: 1,
			laranja: numfrutaXcaixa
		},
		{
			caixote: 1,
			caixa: numcaixaXcaixote,
			laranja: numLarOne
		},
		{
			caixote: 3,
			caixa: numCaixOne,
			laranja: numLarTotal
		}
		];

		this.lines = _.cloneDeep(this.linesModel);

		this.lines[1].laranja = "";
		this.lines[2].caixa = "";
		this.lines[2].laranja = "";
	}

	elQuant(question, cavXcer, cavtotal){
		if(question[4])
			this.pergunta = question[0]+cavXcer+question[1]+question[2]+cavtotal+question[3]+question[4];
		else
			this.pergunta = question[0]+cavXcer+question[1]+question[2]+cavtotal+question[3];
	}

	lineValue(index, type){
		let numReturn = this.lines[index][type];
		if(numReturn === 0)
			return "";
		else
			return numReturn;
	}

	updateRelationDiffer(obj){
		let $ctrl = this;
		return this.$q(function(resolve) {
			$ctrl.calcRelation(obj);
			resolve(obj);
		});
	}

	confirmState(){
		if(_.find(this.lines,function(o) { return o.laranja==="" || o.caixa ==="" || o.laranja===null || o.caixa ===null}))
			return 'locked';
		else
			return false;
	}

	checkEmpty(arr){
		if(typeof arr !== Array && typeof arr !== "object"){
			if(arr !== "")
				return true
		}
		else if(arr.some( i => i === ""))
			return true
		else {
			for(const el of arr){
				const values = Object.values(el)
				if(values.some( i => i === "" || i === null))
					return false
			}
			return true
		}
	}

	checkValue(){
		let answer = this.lines || this.awnserValue;
		if(this.checkEmpty(answer)){
			if(_.isEqual(answer, this.linesModel)){
				this.stageCompleted();
				this.Dialog.showFeedback(this.prize, this.goHome.bind(this));
			}
			else{
				this.Dialog.showAlert();
			}
		}
	}

	calcRelation(obj){
		let name = obj.type;
		switch(name){
			case 'caixote':
			this.elements[1].value = obj.value * this.linesModel[1].caixa;
			this.elements[2].value = obj.value * this.linesModel[1].laranja;
			break;
			case 'caixa':
			this.elements[0].value = Math.floor(obj.value/this.linesModel[1].caixa);
			this.elements[2].value = obj.value * this.linesModel[0].laranja;
			break;
			case 'laranja':
			this.elements[0].value = Math.floor(obj.value/this.linesModel[1].laranja);
			this.elements[1].value = Math.floor(obj.value/this.linesModel[0].laranja);
			break;
		}
	}
	
	update(ob){
		let num = ob.value;
		if(num<1)
			ob.value = "";
		else if(num>ob.maxValue){
			ob.value = ob.maxValue;
		}
		if(this.stageName==='Oeste'){
			let promise = this.updateRelation(ob);
			promise.then(()=>this.elements.forEach(o => this.checkGrid(o)));
		} else {
			let promise = this.updateRelationDiffer(ob);
			promise.then(()=>this.elements.forEach(o => this.checkGrid(o)));
		}
	}

	normalizeFive(num){
		if(num % 5 === 0)
			return num;
		else
			return num - (num % 5);
	}

	$onDestroy(){
		this.resetStage();
	}

	resetStage(){
		this.elements.forEach(function(o){
			o.value = o.minValue;
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/stage-one/stage-one.controller.js